var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconVilla = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  d: "m20.95 8.4-8-6a.75.75 0 0 0-.9 0l-8 6a.75.75 0 0 0 .9 1.2l.8-.6v12c0 .41.34.75.75.75h12c.41 0 .75-.34.75-.75V9l.8.6c.14.1.29.15.45.15a.75.75 0 0 0 .45-1.35Zm-10.7 11.85V18c0-.14.11-.25.25-.25h4c.14 0 .25.11.25.25v2.25h-4.5Zm7.5 0h-1.5V18c0-.96-.79-1.75-1.75-1.75h-4c-.96 0-1.75.79-1.75 1.75v2.25h-1.5V7.87l5.25-3.94 5.25 3.94v12.38Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  d: "M9.75 10v4c0 .41.34.75.75.75h4c.41 0 .75-.34.75-.75v-4c0-.41-.34-.75-.75-.75h-4c-.41 0-.75.34-.75.75Zm1.5.75h2.5v2.5h-2.5v-2.5Z"
})));
export default SvgIconVilla;